import React, { useState } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getAttributeCategories, addAttributeCategory, deleteAttributeCategory } from '../../../../redux/methods/attributes';

import { Container, Row, Button } from 'reactstrap';

import CategoriesTable from '../../../../components/tables/CategoriesTable';
import useFetch from '../../../../hooks/useFetch';

import { withFormUtils } from '../../../../hoc/withFormUtils';

const propTypes = {
    attributeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    forceRefetch: PropTypes.bool,
    getAttributeCategories: PropTypes.func,
    addAttributeCategory: PropTypes.func,
    deleteAttributeCategory: PropTypes.func
};

const SharedEditAssignedCategoriesSection = ({
    utils, attributeId, forceRefetch, getAttributeCategories, addAttributeCategory, deleteAttributeCategory
}) => {
    const intl = useIntl();
    const translations = intl.messages.features.edit.tabs.categories;

    const [ categoryIdSelection, setCategoryIdSelection ] = useState([]);

    const [ data ] = useFetch(getAttributeCategories, attributeId, [], forceRefetch);

    const handleSelection = categoryId => {
        setCategoryIdSelection(categoryIdSelection.indexOf(categoryId) !== -1
            ? categoryIdSelection.filter(id => id !== categoryId)
            : [ ...categoryIdSelection, categoryId ]);
    };

    const handleDeleteAttributeCategory = categoryId => {
        deleteAttributeCategory({ attributeId: attributeId, categoryId: [categoryId]});
    };

    const handleCategorySelectModalOpen = () => {
        utils.selectCategory(
            categoryId => addAttributeCategory({ attributeId: attributeId, categoryId: [categoryId]}),
            translations.categorySelectionModal.body
        );
    };

    const handleDeletionModalOpen = () => {
        utils.confirm(
            () => deleteAttributeCategory({ attributeId: attributeId, categoryId: categoryIdSelection}),
            translations.deletionModal.header,
            translations.deletionModal.body
        );
    };

    return data ? (
        <React.Fragment>
            <Container fluid>
                <CategoriesTable
                    categories={data}
                    checkedCheckboxList={categoryIdSelection}
                    columnNames={translations.table.columnNames}
                    tooltipTranslation={translations.table.tooltip}
                    emptyTranslation={translations.table.placeholder}
                    deleteModalTranslations={translations.table.deleteModal}
                    checkboxAction={handleSelection}
                    removeAction={handleDeleteAttributeCategory}
                />
                <Row className={clsx('d-flex flex-row mt-5', data && data.length > 0 ? 'justify-content-between' : 'justify-content-end')}>
                    {
                        data && data.length > 0 && (
                            <Button
                                outline
                                type="button"
                                disabled={!categoryIdSelection || categoryIdSelection.length === 0}
                                onClick={handleDeletionModalOpen}
                                color="danger"
                            >
                                <i className="fa fa-trash-o mr-2"/>
                                <span>{translations.controls.remove}</span>
                            </Button>
                        )
                    }
                    <Button onClick={handleCategorySelectModalOpen} color="primary">
                        <i className="fa fa-plus mr-2"/>
                        <span>{translations.controls.add}</span>
                    </Button>
                </Row>
            </Container>
        </React.Fragment>
    ) : null;
};

SharedEditAssignedCategoriesSection.propTypes = propTypes;

const mapStateToProps = state => ({
    forceRefetch: state.refetchers.attributesCategories,
});

const mapDispatch = {
    getAttributeCategories,
    addAttributeCategory,
    deleteAttributeCategory
};

export default withFormUtils(connect(mapStateToProps, mapDispatch)(SharedEditAssignedCategoriesSection));